import styled from "styled-components/macro";
import { Colors } from "../../odc-ui";

// Gold call-to-action strip at the top of the dashboard (promotions, claim rewards).
//
// Deliberately a plain styled.div, NOT styled(Frame). Each dashboard pack is its own webpack
// bundle with its own styled-components copy, and every copy injects Frame's rules (same class
// name, `padding: 0`) into its own <style> tag. Whichever tag landed last then overrode the
// `padding: 20px` of a styled(Frame) banner from the other pack, so a banner lost its padding
// at random depending on which AJAX response arrived first. Here every property lives in one
// rule and variants are picked by prop (one complete class per variant), so no other rule can
// win the cascade.
const DashboardBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || Colors.gold100};
  border-radius: 20px;
  padding: 20px;
  color: ${Colors.white};
`;

export default DashboardBanner;
